import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourcefulService } from './resourcefulService';
import { Filiale } from '../models/filiale';

@Injectable({
    providedIn: 'root'
})
export class FilialeService extends ResourcefulService<Filiale>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Filiale);
    }
}
